module.exports = __webpack_public_path__ + "img/cate-4-6863dd.png";